import InputGroup from "../input-group/input-group";

const STDepression = ({ loc, onChanged, data: { STDeprTo_uV }, minST, maxST }) => (
    <div className="ctrl-input-group-ST">
        <InputGroup
            {...{
                id: "edit.STDepr",
                title: loc("report.params.ST_depr_to"),
                val: STDeprTo_uV,
                units: loc("units.uV"),
                _key: "STDeprTo_uV",
                min: minST,
                max: maxST,
                onChanged
            }}
            clearable
        />
    </div>
);

export default STDepression;
